import React, { useState, useEffect } from 'react';
import { FaCookie, FaTimes } from 'react-icons/fa';

const CookiePopup: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setTimeout(() => setIsVisible(true), 2000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9998] p-4 animate-slide-up">
      <div className="glass rounded-xl p-6 max-w-4xl mx-auto shadow-2xl">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
          <FaCookie className="text-4xl text-accent-primary flex-shrink-0" />
          <div className="flex-1">
            <h3 className="text-xl font-bold mb-2">We Use Cookies</h3>
            <p className="text-gray-400 text-sm mb-4">
              We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. 
              By clicking "Accept All", you consent to our use of cookies. 
              <a href="/cookies" className="text-accent-primary hover:underline ml-1">Learn more</a>
            </p>
          </div>
          <div className="flex gap-3 flex-shrink-0">
            <button
              onClick={handleDecline}
              className="px-4 py-2 bg-dark-card text-gray-400 rounded-lg hover:bg-dark-hover transition-colors"
            >
              Decline
            </button>
            <button
              onClick={handleAccept}
              className="px-6 py-2 bg-gradient-to-r from-accent-primary to-accent-secondary text-white rounded-lg hover:shadow-lg hover:shadow-accent-primary/50 transition-all"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePopup;

